<template>
  <div class="col-span-full lg:col-span-3">
    <MobileMenu :is-open="isOpen" @toggle="isOpen = !isOpen" :authStatus="authStatus">
      <NavLink to="Dashboard" text="Översikt" v-if="authStatus" />
      <NavLink to="Profile" text="Profil" v-if="authStatus" />
      <NavLink to="AgreementsInvoices" :text="hasContract ? 'Avtal och fakturor' : 'Fakturor'" v-if="authStatus && (hasContract || hasInvoices)"/>
      <NavLink to="Offers" text="Intresseanmälningar<br>och erbjudanden" v-if="authStatus && !isCompany && !tooYoung" />
      <NavLink to="Subscriptions" text="Bevakningar" v-if="authStatus && !isCompany && !tooYoung" />
      <NavLink to="Laundry" text="Tvättstuga och lokaler" v-if="authStatus && hasActiveOrTerminatedResidentalContract" />
      <NavLink to="ErrorReports" text="Felanmälan" v-if="authStatus && hasActiveOrTerminatedContract" />
      <NavLink to="DwellingStatus" text="Underhåll" v-if="authStatus && !isSecondaryTenant && hasActiveResidentalContract" />
      <NavLink to="OptionalsStart" text="Tillval" v-if="authStatus && !isSecondaryTenant && hasActiveResidentalContract" />
      <NavLink to="Messages" text="Kontakta oss" v-if="authStatus" />
      <NavLink to="Logout" text="Logga ut" v-if="authStatus" />
    </MobileMenu>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import NavLink from '@/components/navigation/nav-link';
import MobileMenu from '@/components/navigation/mobile-menu';
import {filter} from "lodash";

export default {
  name: 'navigation',
  components: { NavLink, MobileMenu },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    ...mapGetters({
      authStatus: 'authStatus',
      hasActiveOrComingContract: 'hasActiveOrComingContract',
      hasActiveResidentalContract: 'hasActiveResidentalContract',
      hasActiveOrTerminatedResidentalContract: 'hasActiveOrTerminatedResidentalContract',
      hasActiveOrTerminatedContract: 'hasActiveOrTerminatedContract',
      hasContract: 'hasContract',
      hasInvoices: 'hasInvoices'
    }),

    tooYoung() {
      return this.$store.getters.claims.some((el) => el == 'youth');
    },

    isSecondaryTenant() {
      return this.$store.getters.claims.some((el) => el == 'secondaryRentalContract');
    },

    isCompany() {
      return this.$store.getters.claims.some((el) => el == 'company');
    },

  },
  watch: {
    // Close navigation when route changes
    $route(val) {
      this.isOpen = false;
    },
  },
};
</script>
